import { ApiService } from 'services';
import { omit, omitBy, get } from 'lodash';
const { REACT_APP_PORTAL_ID } = process.env;

const portalId = REACT_APP_PORTAL_ID;

async function getTokens() {
  return await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/portals/${portalId}/tokens/me`,
  });
}

function getSelectedToken(tokens) {
  let selectedToken;
  const previouslySelectedToken = sessionStorage.getItem('selectedToken');
  if (previouslySelectedToken && previouslySelectedToken !== 'undefined') {
    selectedToken = JSON.parse(previouslySelectedToken);
    const findToken = tokens.find((token) => token && token.id === selectedToken.id);
    // if selected token is not on the tokens list then return first token
    if (!findToken) {
      return tokens[0];
    } else {
      return findToken;
    }
  } else {
    return tokens[0];
  }
}

async function postValidateTransfer(tokenId, data) {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: `/tokens/${tokenId}/actions/validate/transfer`,
    body: data,
  }).then((res) => {
    if (!res.valid) throw new Error(res.reason);
    else return res;
  });
}

async function postInitSimpleTransfer(tokenId, data) {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: `/tokens/${tokenId}/actions/transfer`,
    body: data,
  }).then((res) => {
    if (res.reason !== null) throw new Error(res.reason);
    else return res;
  });
}

async function postConditionalTransfer(tokenId, data) {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: `/tokens/${tokenId}/requests/conditional-transfer`,
    body: data,
  }).then((res) => {
    if (res.reason !== null) throw new Error(res.reason);
    else return res;
  });
}

async function postValidateDvdTransfer(tokenId, data) {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: `/tokens/${tokenId}/actions/validate/dvd-transfer`,
    body: data,
  });
}

async function postSendDvdTransfer(tokenId, data) {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: `/tokens/${tokenId}/actions/dvd-transfer`,
    body: data,
  });
}

function getTokenRequests(tokenId, query) {
  const cleanQuery = omitBy(query, (value) => !value);
  const filter = get(cleanQuery, 'filter', {});

  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/tokens/${tokenId}/requests`,
    queryParams: {
      ...omit(cleanQuery, 'filter'),
      ...filter,
    },
  });
}

function getTokenRequestsMeReceived(tokenId, query) {
  const cleanQuery = omitBy(query, (value) => !value);
  const filter = get(cleanQuery, 'filter', {});

  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/tokens/${tokenId}/requests/me/received`,
    queryParams: {
      ...omit(cleanQuery, 'filter'),
      ...filter,
    },
  });
}

function getTokenRequestsMeSent(tokenId, query) {
  const cleanQuery = omitBy(query, (value) => !value);
  const filter = get(cleanQuery, 'filter', {});

  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/tokens/${tokenId}/requests/me/sent`,
    queryParams: {
      ...omit(cleanQuery, 'filter'),
      ...filter,
    },
  });
}

async function postCancelTokenRequests({ tokenId, requestId }) {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: `/tokens/${tokenId}/requests/${requestId}/conditional-transfer/cancel`,
  });
}

async function getStableCoins(network) {
  const res = await ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/tokens/stable-coins`,
    queryParams: network ? { network } : {},
  });
  return res?.filter((coin) => coin.address);
}

async function postDvdTransferRequestApprove({ tokenId, requestId, ...data }) {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: `/tokens/${tokenId}/requests/${requestId}/dvd-transfer/approve`,
    body: data,
  });
}

async function postDvdTransferRequestCancel({ tokenId, requestId }) {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: `/tokens/${tokenId}/requests/${requestId}/dvd-transfer/cancel`,
  });
}

async function getTokenDocuments({ tokenId, language }) {
  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/tokens/${tokenId}/documents/me`,
    queryParams: {
      language,
    },
  });
}

async function getTokenValuation({ tokenId, from, to }) {
  return ApiService.callApiAuthenticated({
    method: 'GET',
    path: `/tokens/${tokenId}/valuation/me`,
    queryParams: from && to ? { from, to } : {},
  });
}

async function broadcastTransfer(tokenId, params) {
  return ApiService.callApiAuthenticated({
    method: 'POST',
    path: `/tokens/${tokenId}/actions/transfer/broadcast`,
    body: params,
  });
}

export default {
  getTokens,
  getSelectedToken,
  postValidateTransfer,
  postInitSimpleTransfer,
  postConditionalTransfer,
  postCancelTokenRequests,
  getTokenRequests,
  getTokenRequestsMeReceived,
  getTokenRequestsMeSent,
  postDvdTransferRequestApprove,
  postDvdTransferRequestCancel,
  getStableCoins,
  postValidateDvdTransfer,
  postSendDvdTransfer,
  getTokenDocuments,
  getTokenValuation,
  broadcastTransfer,
};
